import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ListOptions from './ListOptions';
import {
  optimizeSearch,
  getOptions,
  toggleUrlVal,
} from '../../Actions/FindMyPart.action';
import { translate } from '../../Services/translation';

const FindMyPartOptionsGeneral = ({
  activeSegment,
  isInBlock,
  initBrandValue,
  initModelValue,
  initYearValue,
  preSetSegment,
  wipeSearchResults,
  ignoreSetCookie = false,
  isSearch = false,
}) => {
  const dispatch = useDispatch();
  const brandsRef = useRef();
  const modelsRef = useRef();
  const yearsRef = useRef();
  const submitRef = useRef();
  const [selectedBrand, setSelectedBrand] = useState({});
  const [selectedModel, setSelectedModel] = useState({});
  const [selectedYear, setSelectedYear] = useState({});
  const [doAutoSearch, setDoAutoSearch] = useState(false);
  const [customerBrandChanged, setCustomerBrandChanged] = useState(false);
  const [lastChangedOptionType, setLastChangedOptionType] = useState();
  const optionsGeneral = useSelector(
    (state) => state.findMyPart.options?.optionsGeneral
  );
  const getSelectedOptionsObject = () => {
    const options = {
      segment: activeSegment,
      ignoreSetCookie,
      lastChangedOptionType:
        isInBlock && selectedModel ? 'model' : lastChangedOptionType,
      optionsGeneral: {
        brand: selectedBrand,
        model: selectedModel,
        year: selectedYear,
      },
      optionsPsg: null,
    };
    return options;
  };

  const optimize = () => {
    if (
      !selectedBrand?.value &&
      !selectedModel?.value &&
      !selectedYear?.value
    ) {
      return;
    }
    const options = getSelectedOptionsObject();
    dispatch(optimizeSearch(options));
  };

  const getServerSideSelectedOption = (items) => {
    return items?.find((x) => x.selected) || {};
  };
  useEffect(() => {
    if (initBrandValue?.value) {
      setSelectedBrand(initBrandValue);
    }
  }, [initBrandValue]);
  useEffect(() => {
    if (initModelValue?.value) {
      setSelectedModel(initModelValue);
    }
  }, [initModelValue]);

  useEffect(() => {
    if (initYearValue?.value) {
      setSelectedYear(initYearValue);
    }
  }, [initYearValue]);

  useEffect(() => {
    if (selectedBrand) {
      if (customerBrandChanged) {
        wipeSearchResults();
      }
    }
  }, [selectedBrand]);

  useEffect(() => {
    if (
      doAutoSearch &&
      selectedBrand?.value &&
      selectedModel?.value &&
      selectedYear?.value
    ) {
      optimize();
      setDoAutoSearch(false);
    }
  }, [doAutoSearch]);

  useEffect(() => {
    if (selectedBrand?.value || selectedModel?.value || selectedYear?.value) {
      setDoAutoSearch(true);
    }
  }, [selectedBrand, selectedModel, selectedYear]);

  useEffect(() => {
    if (lastChangedOptionType) {
      const options = getSelectedOptionsObject();
      dispatch(getOptions(options));
    }
  }, [lastChangedOptionType, selectedBrand, selectedModel]);

  useEffect(() => {
    console.log('initBrandValue', initBrandValue);
    if (isInBlock) {
      setSelectedBrand(initBrandValue);
      setSelectedModel(initModelValue);
      setSelectedYear(initYearValue);
    } else {
      setSelectedBrand(initBrandValue || {});
      setSelectedModel(initModelValue || {});
      setSelectedYear(initYearValue || {});
    }
    setLastChangedOptionType('');
  }, [activeSegment]);
  //useEffect(() => {
  //  if (optionsGeneral && isInBlock) {
  //  }
  //}, [optionsGeneral]);
  useEffect(() => {
    if (!optionsGeneral?.years?.length > 0) {
      setSelectedYear({});
    }
  }, [optionsGeneral]);

  return (
    <Fragment>
      {optionsGeneral && (
        <div className="row find-my-part__options-container">
          {optionsGeneral.brands && (
            <div className="find-my-part__option small-12 medium-4 large-3 columns">
              <ListOptions
                id="fmpBrand"
                title={translate('findmypart.brand')}
                isSearch={isSearch}
                selectRef={brandsRef}
                selectedOption={
                  selectedBrand?.value
                    ? selectedBrand
                    : getServerSideSelectedOption(optionsGeneral.brands)
                }
                initVal={selectedBrand}
                list={optionsGeneral.brands}
                setSelectedOption={(val) => {
                  setSelectedBrand(val);
                  setSelectedModel({});
                  setSelectedYear({});
                  setCustomerBrandChanged(true);
                  setLastChangedOptionType('brand');
                }}
                defaultText={translate('findmypart.selectbrand')}
                tabIndex={1003}
              />
            </div>
          )}
          {optionsGeneral.models && (
            <div className="find-my-part__option small-12 medium-4 large-3 columns">
              <ListOptions
                id="fmpModels"
                isSearch={isSearch}
                title={translate('findmypart.model')}
                selectRef={modelsRef}
                selectedOption={
                  selectedModel?.value
                    ? selectedModel
                    : getServerSideSelectedOption(optionsGeneral.models)
                }
                initVal={selectedModel}
                list={optionsGeneral.models}
                setSelectedOption={(val) => {
                  setSelectedModel(val);
                  setSelectedYear({});
                  setLastChangedOptionType('model');
                }}
                defaultText={translate('findmypart.selectmodel')}
                tabIndex={1004}
              />
            </div>
          )}
          {optionsGeneral.years && (
            <div
              className="find-my-part__option small-12 medium-4 large-3 columns"
              ref={yearsRef}
            >
              <ListOptions
                id="fmpYear"
                isSearch={isSearch}
                title={translate('findmypart.year')}
                selectRef={yearsRef}
                selectedOption={
                  selectedYear?.value
                    ? selectedYear
                    : getServerSideSelectedOption(optionsGeneral.year)
                }
                initVal={selectedYear}
                list={optionsGeneral.years}
                setSelectedOption={(val) => setSelectedYear(val)}
                defaultText={translate('findmypart.selectyear')}
                tabIndex={1005}
              />
            </div>
          )}

          <div
            className="find-my-part__button-container small-12 large-3 columns"
            ref={submitRef}
          >
            <label htmlFor="fmpSubmit">&nbsp;</label>
            <button
              className="small-only-expanded"
              disabled={
                !(
                  selectedYear?.value &&
                  selectedYear?.value.length > 0 &&
                  optionsGeneral?.years.length > 0
                )
              }
              id="fmpSubmit"
              onClick={() => optimize()}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                  optimize();
                }
              }}
              tabIndex={1006}
            >
              {translate('findmypart.searchpart')}
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default FindMyPartOptionsGeneral;
